import * as React from 'react';
import { SVGProps } from 'react';

const ArrowOutword = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.45355 2.50315L1.67628 10.2724C1.56089 10.3878 1.41586 10.4441 1.24119 10.4415C1.06651 10.4388 0.921484 10.3798 0.806109 10.2644C0.690721 10.149 0.633026 10.0053 0.633026 9.83331C0.633026 9.66131 0.690721 9.51762 0.806109 9.40223L8.57536 1.62496H1.74519C1.56811 1.62496 1.41967 1.56504 1.29988 1.44521C1.1801 1.32536 1.12021 1.17686 1.12021 0.999709C1.12021 0.822542 1.1801 0.674133 1.29988 0.55448C1.41967 0.434827 1.56811 0.375 1.74519 0.375H9.95032C10.1637 0.375 10.3426 0.447181 10.487 0.591543C10.6313 0.735904 10.7035 0.914785 10.7035 1.12819V9.33331C10.7035 9.5104 10.6436 9.65883 10.5238 9.77861C10.4039 9.8984 10.2554 9.95829 10.0782 9.95829C9.90108 9.95829 9.75268 9.8984 9.63303 9.77861C9.51337 9.65883 9.45355 9.5104 9.45355 9.33331V2.50315Z"
      fill={props.fill ?? '#1C1B1F'}
    />
  </svg>
);

export default ArrowOutword;
